import { OnboardingActions } from './OnboardingActions';

export class OnboardingEvents {
  category = 'Onboarding';
  action = new OnboardingActions();
}
